import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';
const green = '#508b46';
export const useStyles = makeStyles(() => ({
  cardActions: {
    display: 'flex',
    marginTop: '16px',
    flexDirection: 'row-reverse',
    gap: '15px',
  },
  button: {
    minWidth: '125px',
  },
  buttonCancel: {
    minWidth: '125px',
  },
  alias: {
    marginTop: 0,
  },
  hint: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#1b3958',
  },
  viewSiteButton: {},
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginBottom: 6,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, -2px) scale(1)',
      },
    },
  },
}));

export const useStylesCreateDetailAccount = makeStyles(() => ({
  cardActions: {
    display: 'flex',
    marginTop: '16px',
    flexDirection: 'row-reverse',
  },
  button: {
    minWidth: '125px',
  },
  buttonCancel: {
    minWidth: '125px',
  },
  alias: {
    marginTop: 0,
  },
  hint: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#1b3958',
  },
  viewSiteButton: {},
}));

export const useStylesGuildItem = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      background: '#f7f8f8',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '& .MuiCardContent-root': {
        padding: 0,
      },
      '&.disabled': {
        opacity: 0.5,
      },
    },
    infoIcon: {
      fontSize: '20px',
      marginBottom: theme.spacing(-0.8),
      marginInlineStart: theme.spacing(1),
      color: theme.palette.grey[800],
      cursor: 'pointer',
    },
    content: {
      position: 'relative',
      '&.disabled': {},
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
    },
    subtitleText: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
      marginInlineEnd: theme.spacing(1),
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      backgroundColor: '#ffffff',
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,
      color: darkGray,
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 12,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(0),
      marginTop: theme.spacing(0),
          position: 'absolute',
    right: '16px'
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
      cursor: 'pointer',
      '&:hover p': {
        color: theme.palette.primary.main,
      },
      '&.disabled': {
        cursor: 'auto',
        '&:hover p': {
          color: 'initial',
        },
      },
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
    cardHeader: {
      padding: theme.spacing(2),
      borderBottom: `1px solid #d8d1d1`,
    },
    cardInside: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    expiredFlag: {
      background: ligherGray,
      borderBottomLeftRadius: 10,
      padding: theme.spacing(1, 2),
      paddingBottom: theme.spacing(1.5),
      color: '#455b64',
      fontSize: 13,
      position: 'absolute',
      right: 0,
      top: 0,
      fontWeight: 'bold',
    },
    blockedAmount: {
      color: '#263238',
      fontSize: 12,
      fontWeight: 'bold',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(2),
    },
    blockedAmountIcon: {
      color: '#263238',
      fontSize: 16,
      fontWeight: 'normal',
      marginBottom: -5,
      marginInlineEnd: theme.spacing(0.5),
    },
  };
});

export const useStylesGuildItemCartable = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      background: '#f7f8f8',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '& .MuiCardContent-root': {
        padding: 0,
      },
      '&.disabled': {
        opacity: 0.5,
      },
    },
    infoIcon: {
      fontSize: '20px',
      marginBottom: theme.spacing(-0.8),
      marginInlineStart: theme.spacing(1),
      color: theme.palette.grey[800],
      cursor: 'pointer',
    },
    content: {
      position: 'relative',
      '&.disabled': {},
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
    },
    subtitleText: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
      marginInlineEnd: theme.spacing(1),
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      backgroundColor: '#ffffff',
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,
      color: darkGray,
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 12,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(0),
      marginTop: theme.spacing(0),
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
      cursor: 'pointer',
      '&:hover p': {
        color: theme.palette.primary.main,
      },
      '&.disabled': {
        cursor: 'auto',
        '&:hover p': {
          color: 'initial',
        },
      },
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
    cardHeader: {
      padding: theme.spacing(2),
      borderBottom: `1px solid #d8d1d1`,
    },
    cardInside: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    expiredFlag: {
      background: ligherGray,
      borderBottomLeftRadius: 10,
      padding: theme.spacing(1, 2),
      paddingBottom: theme.spacing(1.5),
      color: '#455b64',
      fontSize: 13,
      position: 'absolute',
      right: 0,
      top: 0,
      fontWeight: 'bold',
    },
    blockedAmount: {
      color: '#263238',
      fontSize: 12,
      fontWeight: 'bold',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(2),
    },
    blockedAmountIcon: {
      color: '#263238',
      fontSize: 16,
      fontWeight: 'normal',
      marginBottom: -5,
      marginInlineEnd: theme.spacing(0.5),
    },

    cr: {
      width: '250px',
      padding: '8px',
      position: 'absolute',
      display: 'none',
      'text-align': 'center',
      color: '#FFF',
      'z-index': '2',
      paddingLeft: '50px',
    },
    crtop: {
      top: '25px',
    },
    crleft: {
      right: '-50px',
      transform: 'rotate(45deg)',
    },
    crred: {
      'background-color': '#789395',
    },
  };
});
